export default {
  alias      : 'tramite_tipo_tramite',
  route      : '/app/tramite/tipo_tramite',
  hash       : true,
  store      : true,
  key        : 'id',
  name       : 'descripcion',
  selectable : false,
  default    : {
    id          : null,
    descripcion : null,
    plazo       : null,
    estado      : true
  },
}
